import { Component, ElementRef, Input, OnChanges, inject, viewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogModel, LoadingOverlayComponent, PhotoComponent, ButtonComponent } from 'wecheer-common';
import { Advertiser, Campaign, CampaignTargetUser, CampaignsAdvertiserAdminApiClient, CampaignsCampaignAdminApiClient, CampaignsSafeBoxAdminApiClient, CoinReward, ProductReward, PunchCardStrategy, ReferralStrategy, RewardData } from 'src/app/api/api-campaigns.service.generated';
import { ProductInfo, RewardsProductApiClient } from 'src/app/api/api-rewards.service.generated';

import { ConsumptionFiltersEditComponent } from '../../_/consumption-filters-edit/consumption-filters-edit.component';
import { RewardSelectComponent } from '../../_/reward-select/reward-select.component';
import { formToRewardData, RewardDataEditComponent } from '../../_/reward-data-edit/reward-data-edit.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UploadImageService } from 'src/app/common/services/upload-image.service';
import { UniversalCodeComponent } from 'src/app/advertiser/advertiser-details/advertiser-campaigns/universal-code/universal-code.component';
import { StaffReferralCampaignBannerComponent } from '../../_/staff-referral-campaign-banner/staff-referral-campaign-banner.component';
import { PunchCardCampaignService } from '../punch-card-campaign-edit.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-staff-referral-tab',
  templateUrl: './staff-referral-tab.component.html',
  styleUrls: ['./staff-referral-tab.component.scss'],
  imports: [
    ReactiveFormsModule,
    StaffReferralCampaignBannerComponent,
    RewardDataEditComponent,
    LoadingOverlayComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    FlexLayoutModule,
    MatIconModule,
    PhotoComponent,
    ButtonComponent
  ]
})
export class StaffReferralTabComponent implements OnChanges {
  private fb = inject(FormBuilder);
  private dialog = inject(MatDialog);
  private snackbar = inject(MatSnackBar);
  private campaignsApi = inject(CampaignsCampaignAdminApiClient);
  private advertiserApi = inject(CampaignsAdvertiserAdminApiClient);
  private rewardProductsApi = inject(RewardsProductApiClient);
  private uploadImageService = inject(UploadImageService);
  private safeBoxAdminClient = inject(CampaignsSafeBoxAdminApiClient);
  private punchCardCampaignService = inject(PunchCardCampaignService);


  @Input() strategy: PunchCardStrategy;
  @Input() advertiserId: string;
  @Input() campaignId: string;    // shared campaign id
  // @Input() strategy: StaffCampaignStrategy;

  readonly filters = viewChild<ConsumptionFiltersEditComponent>('filters');
  readonly serviceReward = viewChild<RewardSelectComponent>('serviceReward');
  readonly fileInputThumbnailBanner = viewChild<ElementRef>('fileInputThumbnailBanner');
  readonly staffReferralCampaignBanner = viewChild<StaffReferralCampaignBannerComponent>('staffReferralCampaignBanner');

  campaigns: Campaign[];

  coinRewardOptions = [
    new CoinReward({ coins: 1 }),
    new CoinReward({ coins: 2 }),
    new CoinReward({ coins: 3 }),
    new CoinReward({ coins: 5 }),
    new CoinReward({ coins: 8 }),
    new CoinReward({ coins: 10 }),
    new CoinReward({ coins: 20 }),
    new CoinReward({ coins: 50 }),
    new CoinReward({ coins: 100 })
  ];

  form = new FormGroup({
    staffReferralCampaigns: this.fb.array([], [])
  });
  selectedChannelIndex: number = 0;

  advertiser: Advertiser;
  rewardProductsOptions: RewardData[] = [];
  rewardProducts: ProductReward[];
  isLoading = false;
  uploadKeyReward: string;
  maxFileSize: number = 2 * 1024 * 1024;
  isAdding: boolean;

  get isTargetStaffRole() {
    return this.punchCardCampaignService.targetRole === CampaignTargetUser.Staff;
  }

  async ngOnChanges() {
    if (!this.advertiserId) return;

    this.getAdvertiser();
    this.getProductRewards();

    this.isAdding = !this.campaignId;
    if (!this.isAdding)
      this.getDbReferralCampaigns();
  }

  async getProductRewards() {
    try {
      const productInfos = await lastValueFrom(this.rewardProductsApi.getProductsByAdvertiserId(this.advertiserId, true, false));

      this.rewardProducts = productInfos.map((pi: ProductInfo) =>
        new ProductReward({ productSlug: pi.slug, rewardTitle: pi.name, rewardDescription: pi.description, rewardThumbUrl: pi.photoUrl, rewardPhotoUrl: pi.photoUrl })
      );
      this.rewardProductsOptions = productInfos.map((pi: ProductInfo) =>
        new RewardData({
          productReward: new ProductReward({ productSlug: pi.slug, rewardTitle: pi.name, rewardDescription: pi.description, rewardThumbUrl: pi.photoUrl, rewardPhotoUrl: pi.photoUrl })
        }));

    } finally {
      this.isLoading = false;
    }
  }
  async getAdvertiser() {
    this.advertiser = await lastValueFrom(this.advertiserApi.getAdvertiserById(this.advertiserId));
  }
  async getDbReferralCampaigns() {
    const referralCampaigns = await lastValueFrom(this.campaignsApi.getStaffReferralCampaigns(this.campaignId));

    this.processingBanners(referralCampaigns);
    this.bindStaffReferrals(referralCampaigns);
  }

  async setFormValue(referralCampaigns: Campaign[]) {
    if (!referralCampaigns)
      return;

    this.processingBanners(referralCampaigns);
    this.bindStaffReferrals(referralCampaigns);
  }

  processingBanners(campaigns) {
    for (let campaign of campaigns) {
      campaign.staffReferralBanner = StaffReferralCampaignBannerComponent.setBanners(campaign.staffReferralBanner);
    }
  }

  async onSubmit() {
  }



  getFormStaffReferralCampaigns(): Campaign[] {
    if (!this.form.value.staffReferralCampaigns) return;

    const items = this.form.value.staffReferralCampaigns.map((f: any) => new Campaign({
      id: f.id,
      title: f.title,
      onboardingUrl: f.onboardingUrl,
      description: f.description,
      detailedDescription: f.detailedDescription,
      detailedDescriptionJoined: f.detailedDescriptionJoined,
      advertiser: this.advertiser,
      advertiserId: this.advertiserId,
      shouldAdvertise: !!f.shouldAdvertise,
      canJoin: !!f.canJoin,
      staffReferralThumbnailUrl: f.staffReferralThumbnailUrl,
      staffReferralBanner: StaffReferralCampaignBannerComponent.getBanners(f.staffReferralBanner),
      strategy: new ReferralStrategy({
        name: 'ReferralStrategy',
        refCampaignId: f.refCampaignId,

        productReward: (f.joinReward && f.joinReward.productReward && f.joinReward.productReward.title) ? new ProductReward({ ...f.joinReward.productReward }) : undefined,    // obsolate but still in use
        coinReward: (f.joinReward && f.joinReward.coinReward && f.joinReward.coinReward.coins) ? new CoinReward({ ...f.joinReward.coinReward }) : undefined,                // obsolate but still in use

        joinReward: formToRewardData(f.joinReward),
        firstConsumptionReward: formToRewardData(f.firstConsumptionReward),
        anyConsumptionReward: formToRewardData(f.anyConsumptionReward),
      }),
      isForceUsingMobileApp: f.isForceUsingMobileApp,
      shouldHideParticipatingLocations: !!f.shouldHideParticipatingLocations
    }));

    return items;
  }

  // rules reactive array
  addStaffReferral(): FormGroup {
    const controls = <FormArray>this.form.controls.staffReferralCampaigns;

    const grp = new FormGroup({
      id: new FormControl(),
      refCampaignId: new FormControl(this.campaignId),

      title: new FormControl('', Validators.required),
      onboardingUrl: new FormControl(''),
      description: new FormControl('', Validators.required),
      detailedDescription: new FormControl('', Validators.required),
      detailedDescriptionJoined: new FormControl('', Validators.required),
      shouldAdvertise: new FormControl(''),
      canJoin: new FormControl(''),
      staffReferralThumbnailUrl: new FormControl(),
      staffReferralBanner: new FormControl([]),
      // rewards
      joinReward: new FormControl(),
      firstConsumptionReward: new FormControl(),
      anyConsumptionReward: new FormControl(),
      isForceUsingMobileApp: new FormControl(false),
      shouldHideParticipatingLocations: new FormControl(false)
    });

    controls.push(grp);
    this.selectedChannelIndex = controls.length - 1;

    return grp;
  }
  async removeStaffReferral(index: number) {
    const referralCampaigns = this.getFormStaffReferralCampaigns();
    const deleted = await this.deleteStaffReferralCampaign(referralCampaigns[index]);
    if (deleted) {
      referralCampaigns.splice(index, 1);
      this.bindStaffReferrals(referralCampaigns);
    }
  }
  bindStaffReferrals(campaigns: Campaign[]) {
    const reactiveControls = <FormArray>this.form.controls.staffReferralCampaigns;
    reactiveControls.controls.length = 0;
    reactiveControls.patchValue([]);

    for (let i = 0; i < campaigns.length; i++) {
      const referral = campaigns[i];
      const strategy = referral.strategy as ReferralStrategy;
      const grp = this.addStaffReferral();
      grp.patchValue({
        id: referral.id,

        title: referral.title,
        onboardingUrl: referral.onboardingUrl,
        description: referral.description,
        detailedDescription: referral.detailedDescription,
        detailedDescriptionJoined: referral.detailedDescriptionJoined,
        shouldAdvertise: referral.shouldAdvertise,
        canJoin: referral.canJoin,
        staffReferralThumbnailUrl: referral.staffReferralThumbnailUrl,
        staffReferralBanner: referral.staffReferralBanner ?? [],
        joinReward: strategy.joinReward,
        firstConsumptionReward: strategy.firstConsumptionReward,
        anyConsumptionReward: strategy.anyConsumptionReward,
        isForceUsingMobileApp: referral.isForceUsingMobileApp,
        shouldHideParticipatingLocations: referral.shouldHideParticipatingLocations
      });
    }
  }

  async deleteStaffReferralCampaign(c: Campaign) {
    if (!c.id) return true;    // not in db yet

    const dialogModel = ConfirmDialogModel.danger(
      'Are you sure you want to delete this staff referral campaign?',
      'Delete staff referral campaign?'
    );
    const confirmResult = await dialogModel.show(this.dialog);
    if (!confirmResult) return;

    await lastValueFrom(this.campaignsApi.deleteCampaign(c.id, this.advertiserId));

    this.snackbar.open(`Staff referral campaign was deleted!`, null, { duration: 3000 });
    return true;
  }


  compareRewardFn: ((a: CoinReward, b: CoinReward) => boolean) | null = (a: any, b: any) => a && b && a.coins === b.coins;
  compareProductRewardFn: ((a: ProductReward, b: ProductReward) => boolean) | null = (a: ProductReward, b: ProductReward) => a && b && a.productSlug === b.productSlug;


  async onThumbImageSelected(event, formControl) {
    try {
      const file = event.target.files[0];
      const { result, imageUrl, errorMessage } = await this.uploadImageService.uploadImage(this.uploadKeyReward, file, this.maxFileSize);

      if (!result) {
        this.snackbar.open(errorMessage, 'Dismiss', { duration: 2000 });
        this.fileInputThumbnailBanner().nativeElement.value = '';
      } else {
        formControl?.setValue(imageUrl)
      }
    } catch (err) {
      console.error('upload failed', err);
    }
  }

  async onBannerChange(banners, formControl) {
    formControl?.setValue(banners);
  }

  async onGenerateCode(id: string) {
    var campaignId = this.advertiserId + "@" + id;
    const safeBox = await lastValueFrom(this.safeBoxAdminClient.createUniversalCode(campaignId));
    await lastValueFrom(this.dialog.open(UniversalCodeComponent, { data: safeBox }).afterClosed());
  }

  onRoleChange() {
    if (this.isTargetStaffRole) {
      this.bindStaffReferrals([]);
    }
  }

  isValid(): boolean {
    this.form.value.staffReferralCampaigns.forEach((f: any) => {
      if (f.firstConsumptionReward?.coinReward?.coins < 0 || f.anyConsumptionReward?.coinReward?.coins < 0 || f.joinReward?.coinReward?.coins < 0) {
        this.form.setErrors({ 'invalidRewardStaffReferral': true });
      }
    });
    return this.form.valid;
  }
}
